import React from 'react'
import PropTypes from 'prop-types'
import { ctiLinkCompound, mailToLink } from './ctiLinkCompound.js'

const List = ({ key, article, page }) => {
  const { title, subtitle, publicationDate, html, LinkList, itemPrefix } =
    article
  const links = LinkList.links.map((link) => {
    return ctiLinkCompound(link)
  })

  //set mailto link to be the same as pdf download
  const pdfLink = links.find((link) => {
    return link.type === 'hippo:mirror'
  })
  const emailLink = links.find((link) => {
    return link.type === 'cti:StringCompound'
  })
  emailLink.url = mailToLink(title, pdfLink.url)
  const dateLine = `${new Date(publicationDate).toLocaleDateString('en-us', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })} - ${subtitle}`
  const iconWithLink = (icon, url, text) => {
    return (
      <div className="u-marginTop2gu">
        <div className="u-flex">
          <span className="Icon--material u-textSizeMsrp1 u-textColorBrandLight u-marginRight1gu icon-line-hight-1">
            {icon}
          </span>

          <a
            href={url}
            className="u-textNoWrap u-textSizeMsrm1 u-textBrandLight u-textSecondary u-textKernLoose icon-line-hight-1"
            target="_blank"
            rel="noreferrer"
          >
            {text}
          </a>
        </div>
      </div>
    )
  }
  return (
    <div key={key} className="u-flexAuto u-paddingBottom8gu">
      <span className="u-textBold  u-textSecondary u-textBold u-textColorLight u-marginBottom2gu u-paddingTop1gu u-borderTop u-borderColorPrimaryTemp pdf-pre-header">
        {itemPrefix}
      </span>
      <h3>
        <a href={pdfLink.url} target="_blank" rel="noreferrer">
          {title}
        </a>
      </h3>
      <p>{dateLine}</p>
      <div
        className="Content u-flexAuto u-paddingBottom0"
        dangerouslySetInnerHTML={{
          __html: page.rewriteLinks(html.content),
        }}
      ></div>
      <div className="icons-with-links">
        {iconWithLink('save_alt', pdfLink.url, 'Download')}
        {iconWithLink('email', emailLink.url, 'Email')}
      </div>
    </div>
  )
}
List.propTypes = {
  article: PropTypes.object,
  page: PropTypes.object,
  key: PropTypes.string,
}

export default List
